import React from "react";
import { Col, Row } from "react-bootstrap";
import Skeleton, { SkeletonProps } from "react-loading-skeleton";

import "react-loading-skeleton/dist/skeleton.css";

const LoadingSkeleton = () => {
  return (
    <div className="my-4">
      <Row className="d-lg-none">
        <Col>
          <Skeleton height="1.5em" width="50%" borderRadius={0} />
          <Skeleton width="20%" borderRadius={0} />
        </Col>
      </Row>
      <Row>
        <Col xs={4}>
          <Skeleton className="h-100" borderRadius={0} />
        </Col>
        <Col xs={8}>
          <Row className="d-none d-lg-flex">
            <Col>
              <Skeleton height="1.5em" width="60%" borderRadius={0} />
              <Skeleton width="30%" borderRadius={0} />
            </Col>
          </Row>
          <Row className="pt-4">
            <Col>
              <Skeleton
                width="40%"
                count={3}
                height="0.75em"
                borderRadius={0}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="my-3">
        <Col>
          <Skeleton className="my-1" height="2em" count={3} borderRadius={0} />
        </Col>
      </Row>
    </div>
  );
};

export default LoadingSkeleton;
